import React, { useEffect, useState } from "react";
import DemandTable from "./DashboardTable/DemandTable";
import DashboardDate from "./DashboardMenu/DashboardDate";
import DataChart from "./DashboardChart/Chart";
import { demandInfo } from "../../services/demandHistoryApi";
import {
  compactDateTimeFormat,
  getFormattedDatesJst,
  getJSTDateStr,
  getYesterdayMidnightDateTimeJst,
} from "../../utils/dateformatter";
import MixTable from "./DashboardTable/MixTable";
import MixChart from "./DashboardChart/MixChart";
import { microgridHeaders, yakubaHeaders } from "./DashboardTable/headers";

import { getLatestPastSlot } from "../../utils/timeSlotUtils";
import { downloadExcelWithChartAndData } from "../../utils/chartTableUtils";
import DashboardLayout from "../Layout/DashboardLayout";

const Dashboard = () => {
  // Use yesterdayDateTime in api call of demand if you want first date and time from time slot
  const yesterdayDateTime = getYesterdayMidnightDateTimeJst();
  const today = getFormattedDatesJst();
  const yesterday = getJSTDateStr(-1);
  const isLoggedIn = !!sessionStorage.getItem("session_key");
  const systemId = Number(sessionStorage.getItem("system_id")) || 2;

  const [selectedValue, setSelectedValue] = useState(["microgrid"]);
  const [locationData, setLocationData] = useState({});
  const [demandData, setDemandData] = useState({});
  const [latestDateTime, setLatestDateTime] = useState(null);
  const isYakubaSelected = selectedValue.includes("yakuba");
  const isMicrogridSelected = selectedValue.includes("microgrid");
  const dataToShow = isYakubaSelected
    ? demandData?.kushiro_yakuba || []
    : demandData?.kushiro_microgrid || demandData?.hirono_microgrid || [];
  const isEmptyData = !dataToShow || Object.keys(dataToShow).length === 0;
  const headers = selectedValue.includes("yakuba")
    ? yakubaHeaders
    : microgridHeaders;

  const [isDemandLoading, setIsDemandLoading] = useState(false);
  const [isTableLoading, setIsTableLoading] = useState(false);

  useEffect(() => {
    setLatestDateTime(getLatestPastSlot(yesterday));
  }, [today]);

  useEffect(() => {
    if (!latestDateTime) return;
    const latestDateTimeToApi = compactDateTimeFormat(latestDateTime);
    const fetchDemandInfo = async () => {
      setIsDemandLoading(true);
      try {
        const response = await demandInfo({
          system_id: Number(sessionStorage.getItem("system_id")) || 2,
          request_date: today,
          forecast_datetime: latestDateTimeToApi,
        });
        setDemandData(response?.data || {});
      } catch (error) {
        console.error("Error fetching demand info:", error);
      } finally {
        setIsDemandLoading(false);
      }
    };

    if (isLoggedIn) {
      fetchDemandInfo();
    }
  }, [isLoggedIn, latestDateTime]);

  const handleDownload = () => {
    downloadExcelWithChartAndData({
      canvasId:
        isMicrogridSelected && isYakubaSelected
          ? "myMixChartCanvas"
          : "myChartCanvas",
      demandData,
      dataToShow,
      headers,
      isMicrogridSelected,
      isYakubaSelected,
      filename:
        isMicrogridSelected && isYakubaSelected
          ? "釧路町役場 + マイクログリッド_データ.xlsx"
          : isMicrogridSelected
          ? "マイクログリッド_データ.xlsx"
          : "釧路町役場_データ.xlsx",
    });
  };

  return (
    <>
      {isDemandLoading ? (
        <div className="loading">
          <div className="loader "></div>
        </div>
      ) : (
        <>
          <DashboardLayout
            selectedValue={selectedValue}
            setSelectedValue={setSelectedValue}
            setLocationData={setLocationData}
            locationData={locationData}
          >
            <>
              <DashboardDate
                activationDate={locationData.activation_date}
                onDemandDataFetch={setDemandData}
                onLoadingChange={setIsTableLoading}
                onDownloadCsv={handleDownload}
              />

              {isTableLoading ? (
                <div className="loadingDashboard">
                  <div className="loader"></div>
                </div>
              ) : (
                <>
                  {isMicrogridSelected && isYakubaSelected ? (
                    <MixChart jsonData={demandData} />
                  ) : (
                    <DataChart
                      datasetType={isYakubaSelected ? "yakuba" : (systemId === 3 ? "hirono" : "microgrid")}
                      jsonData={dataToShow}
                      request_Date={demandData.request_date}
                      forecast_datetime={demandData.forecast_datetime}
                    />
                  )}
                  {isMicrogridSelected && isYakubaSelected ? (
                    <MixTable jsonData={demandData} />
                  ) : (
                    <DemandTable
                      datasetType={isYakubaSelected ? "yakuba" : (systemId === 3 ? "hirono" : "microgrid")}
                      jsonData={dataToShow}
                    />
                  )}{" "}
                </>
              )}
            </>
          </DashboardLayout>
        </>
      )}
    </>
  );
};

export default Dashboard;
